module.exports = __webpack_public_path__ + "media/images/top/works02-3051e0a2512e2feba866432731db7a39.jpg";